import { render, staticRenderFns } from "./SubscriptionChangeNotificationIframe.vue?vue&type=template&id=0d5f6e30&"
import script from "./SubscriptionChangeNotificationIframe.vue?vue&type=script&lang=ts&"
export * from "./SubscriptionChangeNotificationIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports